import * as types from './constants';

// Add Group Users
export const addGroupUsersRequest = data => (
  { type: types.ADD_GROUP_USERS_REQUEST, payload: data }
);

export const addGroupUsersDone = data => (
  { type: types.ADD_GROUP_USERS_DONE, payload: data }
);

export const addGroupUsersFailed = errors => (
  { type: types.ADD_GROUP_USERS_FAILED, payload: errors }
);